'use client'

import Cookies from 'js-cookie'

import { csrfCookieName } from '@/core/config/env'

let responseToken: string | null = null
let cookieAtResponse: string | undefined

/** 방금 받은 응답 토큰을 우선하고, 이후 쿠키가 바뀌면 회전된 쿠키를 따른다. */
export function setClientCsrfToken(token: string): void {
  responseToken = token
  cookieAtResponse = Cookies.get(csrfCookieName)
}

export function clearClientCsrfToken(): void {
  responseToken = null
  cookieAtResponse = undefined
}

export function getClientCsrfToken(): string | undefined {
  const cookie = Cookies.get(csrfCookieName)
  if (responseToken !== null && cookie === cookieAtResponse)
    return responseToken
  return cookie
}
